import { render, staticRenderFns } from "./Image_ViewLocal.vue?vue&type=template&id=4af16d5c&"
import script from "./Image_ViewLocal.vue?vue&type=script&lang=js&"
export * from "./Image_ViewLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports